import {TranslateFn} from "@i18n";

export const distToText = (t: TranslateFn, dist?: number | string, ns = "website") =>
  typeof dist === "number" ? t("{{count}} mi", {count: dist, ns}) : null;
